export default {
  SET_COMPANIES (state, companies) {
    state.companies = companies
  },
  REMOVE_RECORD (state, itemId) {
    const companyIndex = state.companies.findIndex((u) => u.id === itemId)
    state.companies.splice(companyIndex, 1)
  }
}
